const listItems = document.querySelectorAll('.js-list-item .service-title-btn');

if(listItems){
    for (let i = 0; i < listItems.length; i++) {
            
        listItems[i].addEventListener("click", function(e){   
            this.parentElement.classList.toggle("active");
            if (e.target.classList.contains('active')){
                return false;
            }
        }, false );
        
    }
}


// WEBPACK FOOTER //
// ./assets/js/src/modules/script.js